<template>
  <div class="dashboard-frame">
    <FloatingHelpdeskWidget/>
    <router-link
      v-if="showHomeFab"
      class="dashboard-home-fab"
      :to="{ name: 'Dashboard' }"
      aria-label="بازگشت به صفحه اصلی داشبورد"
    >
      <b-icon icon="house-door-fill"></b-icon>
    </router-link>
    <DashboardMobile :items="menuItems"/>
    <div class="dashboard-shell">
      <div class="dashboard-shell-inner">
        <div class="dashboard-shell-row">
          <DashboardDesktop :items="menuItems"/>
          <div class="dashboard-shell-main">
            <div class="dashboard-shell-panel" :class="{ 'is-home': isHomePage }">
              <slot></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardMobile from "./DashboardMenu/mobile";
import DashboardDesktop from "./DashboardMenu/desktop";
import FloatingHelpdeskWidget from "./Helpdesk/FloatingHelpdeskWidget.vue";
import "./dashboard-shell.css"

const FORM_SEEN_POLL_MS = 3 * 60 * 1000

export default {
  name: "Layout",
  components: {DashboardMobile, DashboardDesktop, FloatingHelpdeskWidget},
  props: ['menuItems'],
  data() {
    return {
      formSeenTimer: null,
    }
  },
  computed: {
    isAdmin() {
      return this.$store.getters['User/isAdmin']
    },
    isHomePage() {
      return this.$route.name === 'Dashboard'
    },
    showHomeFab() {
      return !this.isHomePage
    }
  },
  watch: {
    isAdmin: {
      immediate: true,
      handler(value) {
        this.stopFormSeenPolling()
        if (value) {
          this.refreshFormSeenCount()
          this.formSeenTimer = setInterval(this.refreshFormSeenCount, FORM_SEEN_POLL_MS)
        }
      }
    }
  },
  beforeDestroy() {
    this.stopFormSeenPolling()
  },
  methods: {
    refreshFormSeenCount() {
      if (document.hidden) {
        return
      }
      this.$store.dispatch('FormSeen/fetchUnseenCount')
    },
    stopFormSeenPolling() {
      if (this.formSeenTimer) {
        clearInterval(this.formSeenTimer)
        this.formSeenTimer = null
      }
    }
  }
}
</script>

<style scoped>
.dashboard-home-fab {
  display: none;
}

@media (max-width: 1280px) {
  .dashboard-home-fab {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: max(14px, env(safe-area-inset-top));
    left: max(14px, env(safe-area-inset-left));
    z-index: 1100;
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background: #1e1e1e;
    color: #fff !important;
    text-decoration: none !important;
    box-shadow: 0 12px 28px rgba(30, 30, 30, 0.32), 0 0 0 3px rgba(235, 61, 96, 0.22);
    font-size: 20px;
  }

  .dashboard-home-fab:hover,
  .dashboard-home-fab:focus {
    background: #eb3d60;
    color: #fff !important;
    outline: none;
    box-shadow: 0 12px 28px rgba(235, 61, 96, 0.35), 0 0 0 3px rgba(30, 30, 30, 0.12);
  }
}

@media print {
  .dashboard-home-fab {
    display: none !important;
  }
}
</style>
